import clsx from 'clsx';

import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/modules/foundation/components/accordion';

import {InlinePortableText} from '../inline-portable-text';

import type {AccordionListFragment} from './query';

export const AccordionListContainer = ({items}: AccordionListFragment) => {
	return (
		<div className={clsx('my-8')}>
			<Accordion type="single" collapsible>
				{items && items.length ? (
					<>
						{items.map((faq) => {
							if (!faq) {
								return null;
							}

							return (
								<AccordionItem key={faq._key} value={faq._key}>
									<AccordionTrigger>
										{faq.title}
									</AccordionTrigger>
									<AccordionContent>
										{faq.content &&
										faq.content.length > 0 ? (
											<InlinePortableText
												value={faq.content}
											/>
										) : null}
									</AccordionContent>
								</AccordionItem>
							);
						})}
					</>
				) : null}
			</Accordion>
		</div>
	);
};
